// @ts-check

const path = require('path');
const {
  SUPPORTED_LOCALES_OBJ,
  SUPPORTED_LOCALES_ARR,
} = require('@zep-us/i18n');

// 이 config 는 server/client 양쪽 런타임에서 require 되며, isBrowser 는 각 런타임에서 평가된다.
const isBrowser = typeof window !== 'undefined';

// ZEP-443 안전망. 전환 프레임 오탐 제거까지 포함 — 상세는 해당 모듈 주석 참고.
const { missingKeyHandler } = require('./src/shared/i18n/missingKeyReport');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: SUPPORTED_LOCALES_OBJ.ko,
    locales: [...SUPPORTED_LOCALES_ARR],
    localeDetection: false,
  },
  debug: false,
  supportedLngs: SUPPORTED_LOCALES_ARR,
  detection: {
    order: [
      'querystring',
      'cookie',
      'localStorage',
      'navigator',
      'htmlTag',
      'path',
      'subdomain',
    ],
  },
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: false,
  localePath: path.resolve('./public/locales'),
  // missingKeyHandler(함수)가 userConfig 에 들어가면서 serverSideTranslations 의
  // 기본 직렬화(serializeConfig:true)가 "function cannot be serialized" 로 빌드를
  //깨뜨린다. config 는 _app 에서 appWithTranslation 으로 직접 주입하므로 직렬화 불필요.
  // @see https://github.com/i18next/next-i18next/blob/v15.2.0/README.md#unserializable-configs
  serializeConfig: false,
  // ZEP-443: 빠진 키 감지 안전망. 클라이언트에서만 켜서 서버 fs-backend 의
  // .missing.json 쓰기를 막고, 누락 키는 missingKeyHandler 로만 보고한다.
  saveMissing: isBrowser,
  missingKeyHandler,
};
